module.exports = __webpack_public_path__ + "media/images/facilities/microphone-7eaea51afb6a34362f94ed79d148c306.png";